import * as React from "react";
import {Layout} from "../Common/components/Layout";
import {Container, Typography} from "@mui/material";
import {Metas} from "../Common/components/Metas";

/**
 * La page "mentions légales"
 * @constructor
 */
export function Legals() {
    return (
        <>
            <Metas title={"Mentions légales"}/>
            <Layout>
                <Container>
                    <Typography variant={"h1"} mb={4}>
                        Mentions Légales
                    </Typography>
                    <Typography gutterBottom>
                        Editeur du site : INVESTIR PUBLICATIONS SAS
                    </Typography>
                    <Typography gutterBottom>
                        Siège social : 10 boulevard de Grenelle, 75015 Paris
                    </Typography>
                    <Typography gutterBottom>
                        Contact : contact@datagora.fr
                    </Typography>
                    <Typography gutterBottom>
                        Immatriculation au Registre du Commerce et des Sociétés de Paris sous le n° 351 660 808
                    </Typography>
                    <Typography gutterBottom>
                        Numéro d’identification Européen : FR7501.351660808
                    </Typography>
                    <Typography gutterBottom>
                        Capital social : 4 177 350 €
                    </Typography>
                    <Typography gutterBottom>
                        Directeur de la publication : Michèle Benbunan, Présidente
                    </Typography>
                    <Typography>
                        Hébergeur : Evolix, 269 Avenue Daumesnil, 75012 Paris, 01 85 08 51 91
                    </Typography>
                </Container>
            </Layout>
        </>
    );
}
